module.exports = __webpack_public_path__ + "static/img_8.f23544f0.jpg";